<template>
  <div>
    <HxHomeContent></HxHomeContent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HxHomeContent from "./hx-home-content.vue";
import { VUE_APP_ID, VUE_UNION_STATION } from "@/assets/js/stationSetting";
export default {
  components: {
    HxHomeContent,
  },

  data() {
    return {
      VUE_APP_ID,
      isMask: false,
      is8v: false,
      isbitda: false,
      isHx: false,
      isDefault: false,
    };
  },
  computed: {
    ...mapGetters({
      darkMode: "user/darkMode",
    }),
  },
  created() {
    if (VUE_UNION_STATION == "MaskEx") {
      this.isMask = true;
    } else if (VUE_UNION_STATION == "bitda") {
      this.isbitda = true;
    } else if (VUE_UNION_STATION == "8V") {
      this.is8v = true;
    } else if (VUE_UNION_STATION == "TopCredit") {
      this.isHx = true;
    } else {
      this.isDefault = true;
    }
  },
};
</script>

<style></style>
